var radii = {
  m: '2px',
  l: '8px'
};
export default radii;